import MultiplicationVisual from "../../components/ClassTwo/NumberMath/MultiplicationVisual";
import MultiplicationWord from "../../components/ClassTwo/NumberMath/MultiplicationWord";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/multiplication/visual-problem", title: "Visual Problem", component: MultiplicationVisual },
    { url: "/class-two/number-math/multiplication/word-problem", title: "Word Problem", component: MultiplicationWord }
];

export default topics;